var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.71 90H25.29c-4.69 0-8.58-3.67-8.86-8.36L12.5 14.55c-.05-.83.25-1.63.81-2.23.57-.6 1.36-.94 2.18-.94h59c.83 0 1.62.34 2.18.94.57.6.86 1.41.81 2.23l-3.93 67.09c-.27 4.68-4.16 8.36-8.85 8.36zM18.68 17.38l3.74 63.91c.09 1.52 1.35 2.71 2.87 2.71h39.42c1.52 0 2.78-1.19 2.87-2.71l3.74-63.91H18.68z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7 17.38H9.3a3 3 0 1 1 0-6h71.4a3 3 0 0 1 0 6z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.73 17.38H31.27a3 3 0 0 1-3-3V8.79A8.8 8.8 0 0 1 37.06 0h15.88A8.8 8.8 0 0 1 61.73 8.79v5.59a3 3 0 0 1-3 3zM34.27 11.38h21.46V8.79A2.8 2.8 0 0 0 52.94 6H37.06a2.8 2.8 0 0 0-2.79 2.79v2.59z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.33 74.99a3 3 0 0 1-2.82-3.17l2.47-42.24a3 3 0 0 1 5.99.35l-2.47 42.24a3 3 0 0 1-3.17 2.82z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.67 74.99c-1.58 0-2.9-1.23-2.99-2.82l-2.47-42.24a3 3 0 0 1 5.99-.35l2.47 42.24a3 3 0 0 1-2.82 3.17z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74.99a3 3 0 0 1-3-3V29.75a3 3 0 1 1 6 0v42.24a3 3 0 0 1-3 3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.8a45738a8efd779b57a97942b081930a.svg";
export { ForwardRef as ReactComponent };